import React from 'react';

const Instructions = ({ show, onClose }) => {
    if (!show) return null;

    return (
        <div className="instructions-overlay">
            <div className="instructions-modal">
                <div className="instructions-header">
                    <h2 className="instructions-title">How to play</h2>
                </div>
                
                <div className="instructions-content">
                    <div className="instruction-item">
                        <div className="instruction-number">1</div>
                        <div className="instruction-item-text">
                            <h3 className="instruction-action">PAIR</h3>
                            <p className="instruction-description">Form the right icon pairs to reveal a Zoho Workplace app.</p>
                        </div>
                    </div>

                    <div className="instruction-item">
                        <div className="instruction-number">2</div>
                        <div className="instruction-item-text">
                            <h3 className="instruction-action">REVEAL</h3>
                            <p className="instruction-description">Every correct pair reveals the 2025 key updates for the app.</p>
                        </div>
                    </div>

                    <div className="instruction-item">
                        <div className="instruction-number">3</div>
                        <div className="instruction-item-text">
                            <h3 className="instruction-action">DISCOVER</h3>
                            <p className="instruction-description">Find all ten apps to see what’s new across the suite. Try for your quickest run!</p>
                        </div>
                    </div>

                    {/* <div className="instruction-item">
                        <div className="instruction-number">4</div>
                        <div className="instruction-item-text">
                            <h3 className="instruction-action">UNCOVER</h3>
                            <p className="instruction-description">the product features of 2025</p>
                        </div>
                    </div> */}
                    
                    <div className="instruction-hint">
                        <img src="./images/SVG/hint.svg" alt="Hint" className="hint-icon" />
                        <p>Hint: The pairs aren't random. Each pair points to a specific app in the suite.</p>
                    </div>
                </div>

                <button className="learn-how-btn" onClick={onClose}>
                    Start
                </button>
            </div>
        </div>
    );
};

export default Instructions;